export default {

  open (state, account) {
    state.dialog = true
    state.isVisibleTab = true
    state.account = {
      account_id: account.account_id,
      prefix: account.prefix,
      login: account.login,
      country: account.country,
      language: account.language,
      entity_id: account.entity_id,
      currency: account.currency,
      bonus_params: account.bonus_params,
      is_bonus_allowed: account.data?.promo?.manual_bonus_issuance ?? true,
    }
  },

  close (state) {
    state.dialog = false
    state.isVisibleTab = false
    state.account = {}
    state.tabType = null
    state.formData = {}
  },

  set_account (state, account) {
    state.account = {
      account_id: account.account_id,
      prefix: account.prefix,
      login: account.login,
      country: account.country,
      language: account.language,
      entity_id: account.entity_id,
      currency: account.currency,
      bonus_params: account.bonus_params,
      is_bonus_allowed: account.data?.promo?.manual_bonus_issuance ?? true,
    }
  },

  open_with_tab (state, { tabType, formData }) {
    state.dialog = true
    state.tabType = tabType
    state.formData = formData || {}
  },

  clear_tab_data (state) {
    state.tabType = null
    state.formData = {}
  }
}
